export const defaultTheme = {
  PRIMARY_COLOR: '#5C04B4',
  SECONDARY_COLOR: '#FFFFFF',
  TERTIARY_COLOR: '#FFFFFF',
  POSITIVE_COLOR: '#06A25A',
  NEGATIVE_COLOR: '#EA2A0C',
  NEUTRAL_COLOR: '#C3C3C3',
  FONT_FAMILY: `Inter, sans-serif`,
  TEXT_DARK_COLOR: '#0F0F0F',
  TEXT_PRIMARY_COLOR: '#3C3C3C',
  TEXT_SECONDARY_COLOR: '#696969',
  TEXT_TERTIARY_COLOR: '#C3C3C3',
};

export const DONUT_CHART_COLORS = ['#15A296', '#2478F0', '#A50FEC', '#ED3FA5', '#F66F1E', '#D2D2D2'];

window.PRIMARY_COLOR = defaultTheme.PRIMARY_COLOR;
window.SECONDARY_COLOR = defaultTheme.SECONDARY_COLOR;
window.TERTIARY_COLOR = defaultTheme.TERTIARY_COLOR;
window.POSITIVE_COLOR = defaultTheme.POSITIVE_COLOR;
window.NEGATIVE_COLOR = defaultTheme.NEGATIVE_COLOR;
window.NEUTRAL_COLOR = defaultTheme.NEUTRAL_COLOR;
window.fontFamily = defaultTheme.FONT_FAMILY;

export const themes = {
  BLACK: 'theme-black',
  GREEN: 'theme-green',
  DARK_GREEN: 'theme-dark-green',
  RED: 'theme-red',
  BLUE: 'theme-blue',
  GRAY: 'theme-gray',
  PURPLE: 'theme-purple',
  ORANGE: 'theme-orange',
  LIGHT_ORANGE: 'theme-light-orange',
  NO_THEME: 'no-theme',
};

export const cardColorTheme = {
  ...themes,
};

export const buttonGroupTheme = {
  GREEN: 'theme-green',
};

export const GREEN_COLOR = '#009688';
export const GRAY_COLOR = '#888';
export const GRAY_ALTO = '#DDDDDD';
export const BLACK_COLOR = '#13232A';
export const WHITE_COLOR = '#fff';
export const SSR_REACHED_LIMIT = 15;
export const DEVIL_GRAY = '#666666';
export const BLUE_COLOR = '#2675ED';
export const SILVER = '#CCCCCC';
export const PURE_BLACK_COLOR = '#3c3c3c';
export const GREY_COLOR = '#969696';
